import { ElementRef } from '@angular/core';
import { TableService } from '../service';
import { SelectableRow as SelectableRowBase } from 'prime-ng-old/table';
import { SelectableRowDblClick as SelectableRowDblClickBase } from 'prime-ng-old/table';
import { PARENT_TABLE } from '../table.injection-token';
import * as i0 from "@angular/core";
import * as i1 from "../service";
export let SelectableRow = /*#__PURE__*/(() => {
  class SelectableRow extends SelectableRowBase {
    constructor(dt, tableService, el) {
      super(dt, tableService, el);
      this.dt = dt;
      this.tableService = tableService;
    }
    isEnabled() {
      return this.uiSelectableRowDisabled !== true;
    }
    static {
      this.ɵfac = function SelectableRow_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SelectableRow)(i0.ɵɵdirectiveInject(PARENT_TABLE), i0.ɵɵdirectiveInject(i1.TableService), i0.ɵɵdirectiveInject(i0.ElementRef));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: SelectableRow,
        selectors: [["", "uiSelectableRow", ""]],
        hostVars: 5,
        hostBindings: function SelectableRow_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("tabindex", ctx.isEnabled() ? 0 : undefined);
            i0.ɵɵclassProp("ui-selectable-row", ctx.isEnabled())("p-highlight", ctx.selected);
          }
        },
        inputs: {
          data: [0, "uiSelectableRow", "data"],
          index: [0, "uiSelectableRowIndex", "index"],
          uiSelectableRowDisabled: "uiSelectableRowDisabled"
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return SelectableRow;
})();
export let SelectableRowDblClick = /*#__PURE__*/(() => {
  class SelectableRowDblClick extends SelectableRowDblClickBase {
    constructor(dt, tableService) {
      super(dt, tableService);
      this.dt = dt;
      this.tableService = tableService;
    }
    isEnabled() {
      return this.uiSelectableRowDisabled !== true;
    }
    static {
      this.ɵfac = function SelectableRowDblClick_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SelectableRowDblClick)(i0.ɵɵdirectiveInject(PARENT_TABLE), i0.ɵɵdirectiveInject(i1.TableService));
      };
    }
    static {
      this.ɵdir = /*@__PURE__*/i0.ɵɵdefineDirective({
        type: SelectableRowDblClick,
        selectors: [["", "uiSelectableRowDblClick", ""]],
        hostVars: 4,
        hostBindings: function SelectableRowDblClick_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("ui-selectable-row", ctx.isEnabled())("p-highlight", ctx.selected);
          }
        },
        inputs: {
          data: [0, "uiSelectableRowDblClick", "data"],
          index: [0, "uiSelectableRowIndex", "index"],
          uiSelectableRowDisabled: "uiSelectableRowDisabled"
        },
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return SelectableRowDblClick;
})();